import { render, staticRenderFns } from "./ContextMenuCustomForTextArea.vue?vue&type=template&id=04b34c2e&scoped=true&"
import script from "./ContextMenuCustomForTextArea.vue?vue&type=script&lang=js&"
export * from "./ContextMenuCustomForTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuCustomForTextArea.vue?vue&type=style&index=0&id=04b34c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b34c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b34c2e')) {
      api.createRecord('04b34c2e', component.options)
    } else {
      api.reload('04b34c2e', component.options)
    }
    module.hot.accept("./ContextMenuCustomForTextArea.vue?vue&type=template&id=04b34c2e&scoped=true&", function () {
      api.rerender('04b34c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/carbon-template/ContextMenuCustomForTextArea.vue"
export default component.exports